import { BestSellerResponseDto } from '../dto/bestseller.dto';
import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';

class BestSellerService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getBestSellers(): Promise<BestSellerResponseDto> {
    return this.__Apiservice.getRequest('products/best-selling', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}

// Create an instance of the service
const bestSellerService = new BestSellerService();

export default bestSellerService;
